import React, { useState, useEffect } from "react";
import { Input } from "antd";

const PercentInput = ({ value, onChange, maxLength, placeholder, ...rest }) => {
    const [inputValue, setInputValue] = useState(value || "");

    // Sync value from parent (e.g., form.setFieldsValue)
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleKeyPress = (e) => {
        const char = e.key;
        const allowedChars = "0123456789.";

        if (!allowedChars.includes(char)) {
            e.preventDefault();
            return;
        }

        const current = inputValue;

        if (char === ".") {
            if (current.includes(".")) {
                e.preventDefault();
            }
        } else {
            if (current.includes(".")) {
                const decimalPart = current.split(".")[1] || "";
                const cursorPos = e.currentTarget.selectionStart;
                const dotPos = current.indexOf(".");
                if (cursorPos > dotPos && decimalPart.length >= 2) {
                    e.preventDefault();
                }
            }
        }
    };

    const handleChange = (e) => {
        let val = e.target.value;

        // Remove invalid characters
        val = val.replace(/[^0-9.]/g, "");

        // Ensure only one dot
        const parts = val.split(".");
        if (parts.length > 2) {
            val = parts[0] + "." + parts.slice(1).join("");
        }

        // Limit to 2 decimal places
        if (parts[1]) {
            val = parts[0] + "." + parts[1].slice(0, 2);
        }

        setInputValue(val);
        if (onChange) onChange(val);
    };

    return (
        <Input
            {...rest}
            value={inputValue}
            onKeyPress={handleKeyPress}
            onChange={handleChange}
            placeholder={placeholder}
            maxLength={maxLength}
        />
    );
};

export default PercentInput;
